import Alpine from 'alpinejs'

const planItemEditor = (initialData = {}) => ({
  productItems: initialData.productItems || [{ id: Date.now().toString(), dbId: null, productId: '', quantity: 1, _destroy: false }],
  shippingFeeItems: initialData.shippingFeeItems || [],
  imageUrl: initialData.imageUrl || '',
  productTomSelectInstances: {},
  shippingFeeTomSelectInstances: {},

  addProductItem() {
    this.productItems.push({ id: Date.now().toString(), dbId: null, productId: '', quantity: 1, _destroy: false })
  },

  removeProductItem(id) {
    const idx = this.productItems.findIndex(i => i.id === id)
    if (idx === -1) return
    const item = this.productItems[idx]
    if (item.dbId) {
      item._destroy = true
    } else {
      this.productItems.splice(idx, 1)
    }
    delete this.productTomSelectInstances[id]
    this.$nextTick(() => this.syncProductTomSelectOptions())
  },

  getSelectedProductIds(excludeItemId = null) {
    return this.productItems
      .filter(item => !item._destroy && item.id !== excludeItemId && item.productId)
      .map(item => item.productId.toString())
  },

  syncProductTomSelectOptions() {
    this.productItems.forEach(item => {
      if (item._destroy) return
      const ts = this.productTomSelectInstances[item.id]
      if (!ts) return

      const usedByOthers = this.getSelectedProductIds(item.id)

      Object.keys(ts.options).forEach(value => {
        if (!value) return
        const option = ts.options[value]
        option.disabled = usedByOthers.includes(value.toString())
      })

      ts.clearCache('option')
      ts.refreshOptions(false)
    })
  },

  initProductTomSelect(el, itemId, value) {
    if (el.tomselect) return
    const ts = new TomSelect(el, {
      allowEmptyOption: true,
      plugins: ['input_autogrow']
    })
    if (value) {
      ts.setValue(value, true)
    }

    this.productTomSelectInstances[itemId] = ts

    ts.on('change', (selectedValue) => {
      const item = this.productItems.find(i => i.id === itemId)
      if (item) {
        item.productId = selectedValue
      }
      this.$nextTick(() => this.syncProductTomSelectOptions())
    })

    this.$nextTick(() => this.syncProductTomSelectOptions())
  },

  getSelectedShippingCountries(excludeItemId = null) {
    return this.shippingFeeItems
      .filter(item => item.id !== excludeItemId && item.country)
      .map(item => item.country.toString())
  },

  syncShippingFeeTomSelectOptions() {
    this.shippingFeeItems.forEach(item => {
      const ts = this.shippingFeeTomSelectInstances[item.id]
      if (!ts) return

      const usedByOthers = this.getSelectedShippingCountries(item.id)

      Object.keys(ts.options).forEach(value => {
        if (!value) return
        const option = ts.options[value]
        option.disabled = usedByOthers.includes(value.toString())
      })

      ts.clearCache('option')
      ts.refreshOptions(false)
    })
  },

  initShippingFeeTomSelect(el, itemId, value) {
    if (el.tomselect) return
    const ts = new TomSelect(el, {
      allowEmptyOption: true,
      plugins: ['input_autogrow']
    })
    if (value) {
      ts.setValue(value, true)
    }

    this.shippingFeeTomSelectInstances[itemId] = ts

    ts.on('change', (selectedValue) => {
      const item = this.shippingFeeItems.find(i => i.id === itemId)
      if (item) {
        item.country = selectedValue
      }
      this.$nextTick(() => this.syncShippingFeeTomSelectOptions())
    })

    this.$nextTick(() => this.syncShippingFeeTomSelectOptions())
  },

  cloneImageTemplate(container, index) {
    if (container.children.length > 0) return
    const tpl = document.getElementById('plan-image-upload-template')
    if (!tpl) return
    const clone = tpl.content.cloneNode(true)
    const walker = document.createTreeWalker(clone, NodeFilter.SHOW_ELEMENT)
    while (walker.nextNode()) {
      const el = walker.currentNode
      for (const attr of Array.from(el.attributes)) {
        if (attr.value.includes('__NEW_INDEX__')) {
          el.setAttribute(attr.name, attr.value.replaceAll('__NEW_INDEX__', index))
        }
      }
    }
    container.appendChild(clone)
  },

  updateImageInputNames(container, index) {
    container.querySelectorAll('input[name*="plans_attributes"]').forEach(el => {
      el.name = el.name.replace(/(plans_attributes\])\[[^\]]+\]/, `$1[${index}]`)
    })
  },

  addShippingFee() {
    this.shippingFeeItems.push({ id: Date.now().toString(), country: '', fee: 0 })
  },

  removeShippingFee(id) {
    const ts = this.shippingFeeTomSelectInstances[id]
    if (ts) ts.destroy()
    delete this.shippingFeeTomSelectInstances[id]

    const idx = this.shippingFeeItems.findIndex(item => item.id === id)
    if (idx !== -1) {
      this.shippingFeeItems.splice(idx, 1)
    }
    this.$nextTick(() => this.syncShippingFeeTomSelectOptions())
  }
})

Alpine.data('planItemEditor', planItemEditor)
export default planItemEditor
